import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import { FinalTableConfig } from "@beeldit/core/models/FinalTableConfig.interface";
import { Eye, Trash, Plus, ArrowsClockwise, Pencil, Lock, LockOpen } from "@phosphor-icons/react";

const tableConfig: FinalTableConfig = {
      index: null,
      actions: [
        {
          name: TableAction.CREATE, 
          label: 'create',
          showLabel: true,
          allowed: true,
          show: true,
          action: null,
          icon: <Plus size={20} />,
        },
      ],
      rowActions: [
        {
          name: RowAction.EDIT, 
          label: 'edit',
          icon: <Pencil size={20} />,
          allowed: true,
          show: (element: any) => {
            return !element.locked;
          },
          action: (element: any) => {
            console.log('edit', element);
          }
        },
        {
          name: RowAction.DELETE, 
          label: 'delete',
          icon: <Trash size={20} />,
          allowed: true,
          show: (element: any) => {
            return !element.locked;
          },
          action: (element: any) => { 
            console.log('delete', element);
          }              
        },
        {
          name: 'lock-session', 
          label: 'lock-session',
          icon: <LockOpen size={20} />,
          allowed: true,
          show: (element: any) => {
            return !element.locked;
          },
          action: (element: any) => { 
            console.log('generate-event-sessions', element);
          }              
        },
        {
          name: 'unlock-session', 
          label: 'unlock-session',
          icon: <Lock size={20} />,
          allowed: true,
          show: (element: any) => {
            return element.locked;
          },
          action: (element: any) => { 
            console.log('generate-event-sessions', element);
          }              
        },
      ],
      rowConfiguration: {
        class: (element: any) => {
          return null;
        }
      },
      columns: [
        {
          name: 'id',
          label: '#',
          key: 'id',
          type: 'number',
          show: true,
          allowOrder: true,
        },
        {
          name: 'date',
          label: 'date',
          key: 'date',
          type: 'string',
          show: true,
          allowOrder: true,
        },
        {
          name: 'event_rule',
          label: 'event_rule',
          key: 'event_rule.name',
          type: 'string',
          show: true,
          allowOrder: true,
        },
      ],
      pagination: {
        enabled: true,
        back: true
    }
}
const getConfig: any = (functions: any) => {
    const {
      getFunction,
      indexFunction,
      initializeFunction,
      prepareRemoveFunction,
      lockFunction,
      unlockFunction,
    } = functions;
    tableConfig.actions[0].action = () => initializeFunction();
    tableConfig.index = () => indexFunction();
    tableConfig.rowActions[0].action = (id: any) => getFunction(id);
    tableConfig.rowActions[1].action = (id: any) => prepareRemoveFunction(id);
    tableConfig.rowActions[2].action = (id: any) => lockFunction(id);
    tableConfig.rowActions[3].action = (id: any) => unlockFunction(id);
    return tableConfig;
}
export default getConfig;